/**
 * Created by Carsten Bühler
 * User: c.buehler on 08.06.2016
 * Copyright: xdot GmbH 2015
 */

import { ClassRemoteDataStore } from 'plugin/liferay-widgets-react-web';
import ClassNames from '../constants/ClassNames';
import LayerDataSourceWebApi from '../webapi/LayerDataSourceWebApi';

export default class LayerDataSourceStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.LayerDataSource, LayerDataSourceWebApi.listLayerDataSourcesByLogicalLayerId, null);
    }

    /*reduce(state, action){
        
        let availableLayers = state.availableLayers || {};
        
        switch(action.type) {
            case ActionTypes.LIST_BY_MAPCONFIG:
                switch (action.meta.asyncState) {
                    case AsyncState.REQUESTED:
                        return {
                            ...state,
                            'availableLayers': {
                                ...availableLayers,
                                [action.payload.mapConfigId]: []
                            }
                        };

                    case AsyncState.SUCCESS:
                        return {
                            ...state,
                            'availableLayers': {
                                ...availableLayers,
                                [action.payload.mapConfigId]: action.payload.item
                            }
                        };
                        break;

                    case AsyncState.ERROR:
                        
                        break;
                    //no default
                }
            default:
                return super.reduce(state, action);
        }
        return state;
    }*/
}



// WEBPACK FOOTER //
// ./js/stores/LayerDataSourceStore.js